const Form106SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "填写意愿书",
        confirmation: "确认",
    },

    importantNotesContent: {
        title: "填写须知",
        p1First: "如你的子女",
        p1FileCheck: "不是儿童体能智力测验中心／测研中心的个案",
        p1Second: "，或你已决定",
        p1ProSubject: "按照专业人士的评估及建议为子女申请于下学年入读特殊学校",
        p1Third: "，便",
        p1NotNeed: "毋须",
        p1End: "填写及交回此家长意愿书。",
        p2: "此网上表格<b><u>必须以「智方便+」进行数码签署以递交</u></b>。",
        p3: "请先参阅以下的注意事项，以了解意愿书的用途和相关安排。",
        termsConditions: "我已阅读、理解并同意上述注意事项、条款和条件。",
    },

    GuidanceNotesContent: {
        title: "注意事项",
        p2: "你的适龄子女将于下学年升读小一。为使有关学校了解你子女的需要，从而为他们尽早提供合适的支援，教育局现征求你的同意，以便向你子女所属的儿童体能智力测验中心／测研中心索取他／她的评估资料。如你同意，教育局会把意愿书送交有关测验中心／测研中心，以便测验中心／测研中心安排一式两份的评估资料送交本局。教育局会于小一「统一派位」结果公布后，尽早把其中一份资料转交你子女将入读的官立、资助或直接资助计划小学，并保留另一份资料备考。教育局所保留的一份资料会在完成上述资料传递工作后被销毁。如有需要，我们会以电话与你联络，确认你子女将入读的小学。",
        p3: "小学如在你的子女入学前取得他们的评估资料，可及早规划，并为他们提供合适的支援。你的子女入学后，如有更新资料（包括跟进评估和其他相关训练及专科跟进等），家长可把相关资料直接交给学校作参考和合适的跟进。",
        termsConditions: "本人理解申请人需要拥有「智方便+」帐户才能处理申请。",
    },

    applicationInformationContent: {
        label: {
            title1: "1.   儿童资料：",
            childNameZh: "中文姓名",
            noChineseName: "没有中文姓名",
            childNameEn: "英文姓名",
            childGender: "性别",
            childGenderOption: {
                male: "男",
                female: "女",
            },
            childBirthDate: "出生日期",
            childHkidOrOtherIdentityDocumentNumber: "身份证明文件类别",
            childHkidOrOtherIdentityDocumentNumberOption: {
                hkid: "香港身份证",
                otherIdNo: "其他身份证明文件",
            },
            childHkidOrOtherIdentityDocumentNumberText: "号码",
            hkid: "香港身份证号码",
            otherIdNo: "其他身份证明文件号码",
            childIdNumber: "身份证明文件号码",
            intendedPrimarySchoolName:
                "若你已为子女注册下学年将入读的官立、津贴或直接资助计划小学，请提供下列资料；若现时未能提供可以略过此项。如有需要，我们稍后会以电话与你联络，确认你子女将入读的小学：",
            district: "地区",
            school: "学校",
            title2: "2.   家长/监护人意愿：",
            childEnrollNextYear1: "我的子女",
            childEnrollNextYear2:
                "于下学年升读小一，并<u>是</u>以下儿童体能智力测验中心／测研中心的个案：",
            willNotOption: {
                yes: "会",
                no: "不会",
            },
            agreeNotOption: {
                yes: "同意",
                no: "不同意",
            },

            trcArchiveNumber: "测验中心／测研中心的档案编号",
            nextStepAgreeEnrollNextYear1: "我",
            nextStepAgreeEnrollNextYear2:
                "上述测验中心／测研中心把我子女的评估资料（如有）送交教育局，并由教育局转交至我子女将入读的官立、资助或直接资助计划小学。",
            nextStepNotAgreeEnrollNextYear1: "我的子女",
            nextStepNotAgreeEnrollNextYear2: "不会",
            nextStepNotAgreeEnrollNextYear3: "于下学年升读小一。我",
            nextStepNotAgreeEnrollNextYear4:
                "教育局适时联络我，跟进评估资料传递至小学的安排。",
            title3: "3.   家长/监护人资料：",
            guardianFullNameOption: {
                parent: "家长",
                legalGuardian: "监护人",
            },
            guardianFullNameOptionName: "姓名",
            guardianFullName: "家长／监护人姓名",
            guardianIdentityDocumentNumber: "身份证明文件号码",
            relationshipToChild: "与儿童关系",
            contactNumber: "联络电话",
            address: "地址",
            guardianSign: "家长／监护人签署",
            guardianSignDate: "签署日期",
            statementCheck: {
                label: "本人谨作以下声明",
                label1: "本人为上述儿童的家长；及",
                label2: "本人为上述儿童的监护人；及",
                label3: "此表格内的资料全属正确无讹。倘若资料有误，本人明白教育局可能无法办理或继续处理有关表格。",
            },
        },

        errorMsg: {
            childNameZh: "中文姓名",
            childNameEn: "英文姓名",
            childGender: "性别",
            childBirthDate: "出生日期",
            childHkidOrOtherIdentityDocumentNumber: "身份证明文件类别",
            childIdNumber: "身份证明文件号码",
            guardianFullName: "家长／合法监护人姓名",
            guardianIdentityDocumentNumber: "身份证明文件号码",
            relationshipToChild: "与儿童关系",
            contactNumber: "联络电话",
            address: "地址",
            guardianSign: "家长／合法监护人签署",
            guardianSignDate: "签署日期",
            numericOnly: "仅限数字",
            cannotContainNumbers: "不能输入数字",
        },
    },
    submittedDialog: {
        note1: "你已成功送出表格。",
        note2: "请将专业发展资料册（附「行动研究计划」）一式两份",
        note3: "连同此申请表",
        note4: "，经由以下方法递交：",
        // note5: "学校发展资料册一式两份",
        note6: "",
        note7: "以专人递交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部〈请在递交日期最少2个工作天前致电3509 7471登记预约〉；或",
        note8: "以挂号邮件寄交至",
        note9: "香港添马添美道2号",
        note10: "政府总部东翼5楼",
        note11: "教育局",
        note12: "专业发展及培训分部",
        note13: "学校领导及专业发展组收",
    },
    parameter: {
        centerSC: "中心名称（简体中文）",
        centerTC: "中心名称（繁体中文）",
        centerEN: "中心名称（英文）",
    },
};

export default Form106SC;
